import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import * as changeCase from 'change-case'

const Icon = (props) => {
  const { height, width, name, size, style, alt, className, flipCondition } =
    props
  const [IconComponent, setIconComponent] = useState(null)
  useEffect(() => {
    const loadIcon = async () => {
      try {
        const ico = await import(
          `!!@svgr/webpack?-svgo,+titleProp,+ref!./../../../assets/fontawesome/${style}/${name}.svg`
        )
        setIconComponent(() => ico.default)
      } catch (err) {
        console.error(err)
      }
      return IconComponent
    }
    loadIcon()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [name, style])

  const baseClasses = `fa ${changeCase.kebabCase(name)} ${
    flipCondition ? 'flip' : ''
  }`

  const iconAttr = {
    className: className ? `${className} ${baseClasses}` : baseClasses,
    height: size || height,
    width: size || width,
    role: 'img',
    alt: alt || name,
  }

  const flipStyle = {
    transition: 'all 0.3s ease',
    ...(flipCondition ? { transform: 'scale(-1, 1)' } : {}),
  }

  return IconComponent ? (
    <IconComponent
      {...iconAttr}
      style={flipCondition === undefined ? {} : flipStyle}
    />
  ) : null
}

Icon.defaultProps = {
  name: 'xmark',
  alt: '',
  width: 16,
  height: 16,
  size: 16,
  style: 'solid',
}

Icon.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
  size: PropTypes.number,
  alt: PropTypes.string,
  style: PropTypes.string,
  flipCondition: PropTypes.bool,
}

export default Icon
